export default class Chamado {

    constructor(resource) {
        this._resource = resource('chamados_supo');
    }

    get(rdata, rresp, rsituacao, rtecnico, rcliente, rdata_fin, rgetTecnico) {
        return this._resource
            .get(
                {
                    rdata: rdata,
                    rresp: rresp,
                    rsituacao: rsituacao,
                    rtecnico: rtecnico,
                    rcliente: rcliente,
                    rdata_fin: rdata_fin,
                    rgetTecnico: rgetTecnico
                }
            )
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    getResolucoes(rchamado) {
        return this._resource
            .get(
                {
                    rchamado: rchamado,
                }
            )
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    save(rdados) {
        return this._resource
            .save({}, rdados)
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    upCliente(rdados) {
        return this._resource
            .update({}, rdados)
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    saveResolucoes(rchamado, rdados) {
        return this._resource
            .save({ rchamado: rchamado }, rdados)
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    delResolucoes(rresolucao) {
        return this._resource
            .delete({ rResolucao: rresolucao })
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    delChamado(rchamado, rtecnico) {
        return this._resource
            .delete({
                rChamado: rchamado,
                rTecnico: rtecnico
            })
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

}